import {action, observable} from 'mobx';
import {databaseRef, firebaseStorage} from '../../helperFunctions/firebaseStore';
import {ICategory, IItem} from "../storeInterfaces/menuStoreInterface";
import {convertObjToArray} from "./ordersStore";
import {IDeal, IDealsStore} from "../storeInterfaces/dealsStoreInterface";


export class DealsStore implements IDealsStore {

    @observable
    categories: ICategory[] = [];
    @observable
    items: IItem[] = [];
    @observable
    deals: IDeal[] = [];
    @observable
    loaded: boolean = false;
    @observable
    failed: boolean = false;

    @action
    getDeals = async () => {
        this.failed = false;
        this.loaded = false;
        try {
            await databaseRef.ref('/categories/').on('value', snapshot => {
                this.categories = snapshot ? convertObjToArray(snapshot.val()) : [];
            });
            await databaseRef.ref('/items/').on('value', snapshot => {
                this.items = snapshot ? convertObjToArray(snapshot.val()) : [];
            });
            await databaseRef.ref('/deals/').on('value', snapshot => {
                this.deals = snapshot ? convertObjToArray(snapshot.val()) : [];
            });
        } catch (e) {
            this.failed = true;
        } finally {
            this.loaded = true;
        }
    };

    @action
    editDeal = async (dealId: string, dataToEdit: IDeal) => {
        Object.keys(dataToEdit).forEach((k: any) => (dataToEdit as any)[k] === undefined ? delete  (dataToEdit as any)[k] : null);
        try {
            if (dataToEdit.image[0].name) {
                const e = await firebaseStorage.ref(`dealsLogos/${dealId}/`).put(dataToEdit.image[0]);
                dataToEdit.image = await e.ref.getDownloadURL();
            }
            if (dataToEdit.image[0].imageUrl) delete dataToEdit.image;
            dataToEdit.discount = dataToEdit.discount ? +dataToEdit.discount : 0;
            await databaseRef.ref('/deals/' + dealId).update(dataToEdit);
        } catch (error) {
            console.log(error);
        }
    };

    @action
    addDeal = async (dealToAdd: IDeal) => {
        Object.keys(dealToAdd).forEach((k: any) => (dealToAdd as any)[k] === undefined ? delete  (dealToAdd as any)[k] : null);
        const dealId = databaseRef.ref('/deals/').push(dealToAdd).key;
        const e = await firebaseStorage.ref(`/dealsLogos/${dealId}/`).put(dealToAdd.image[0]);
        dealToAdd.image = await e.ref.getDownloadURL();
        dealToAdd.discount = dealToAdd.discount ? +dealToAdd.discount : 0;
        return databaseRef.ref('/deals/' + dealId).set({...dealToAdd, dealId});
    };

    @action
    deleteDeal = async (dealId: string) => {
        await firebaseStorage.ref(`/dealsLogos/${dealId}/`).delete();
        return databaseRef.ref('/deals/' + dealId).remove();
    };

    @action
    getDealById = (dealId: string) => {
        return databaseRef.ref('/deals/' + dealId).once('value');
    };
}